import { useNavigate, useParams } from 'react-router-dom';
import history from '../../common/history';
import React, { useEffect, useState, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
// import QrReader from 'react-web-qr-reader';
import { QrReader } from 'react-qr-reader';
import { useGetItemByTno } from '../../../interface/item';
import { useGetInoutHistSel, useGetInoutInfo, useSetInoutHist } from '../../../interface/inout';
import NaviText from '../../backoffice/common/NaviText';
import { Row } from '../../../styles/common';
// import { Collapse, Drawer, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Collapse, Drawer, TextField } from '@mui/material';
import Button from '../../common/Button';
import theme from '../../../styles/theme';
import { useGetCodeList } from '../../../interface/common';
import CommonDataGrid from '../../common/CommonDataGrid';
import MobileMsgModal from '../../common/modal/MobileMsgModal';
import useSound from 'use-sound';
import { useQuery, useQueryClient } from 'react-query';
import FoldingBar from '../../common/FoldingBar';
import moment from 'moment';
import { IOT_TP, ITEM_STATUS, SUB_TP } from '../../common/constants';
// import { usePrompt } from '../../common/prompt';

const MainWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const DrawerInner = styled.div`
    max-height: calc(100vh - 7rem);
    overflow: auto;
    .selected {
        color: ${theme.color.secondary.red};
    }
`;

const QRWrapper = styled.div`
    width: calc(100% - 8rem);
    height: auto;
    section div {
        border: 0 !important;
        box-shadow: none !important;
    }


    video {
        border-radius: 25%;
    }

    border-radius: 25%;
`;
const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 0.9;
    }
`
const Fab = styled.div`
    position: fixed;
    right: 2.5rem;
    top: 5.5rem;
    border-radius: 50%;
    border: 0.8px solid ${theme.color.secondary.puppleB};
    width: 3.5rem;
    height: 3.5rem;
    background: ${theme.color.primary.pupple};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    opacity: 0.9;
    animation: ${fadeIn} 0.8s;
`;

const columns = [
    { field: 'id', headerName: '순번', width:40 },
    { field: 'cat_nm', headerName: '분류', width:80 },
    { field: 'lot_no', headerName: '표기번호', width:100 },
    { field: 'model_nm', headerName: '모델명', width:200 },
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'rid', headerName: '연계자산', width:100 },
]

const OutControl = () => {

    // const delay = 500;
    const delay = 100;

    const queryClient = useQueryClient();

    const navigate = useNavigate();
    const param = useParams();
    
    const [listOpen, setListOpen] = useState(false)
    const [result, setResult] = useState('');
    const [msg, setMsg] = useState('');
    const [fixMsg, setFixMsg] = useState('');
    const [selectItem, setSelectItem] = useState();

    const [msgOpen, setMsgOpen] = useState(false)
    const [retMsg, setRetMsg] = useState('');

    const [sendList, setSendList] = useState([]);
    // const [oRetSt, setORetSt] = useState();
    const [folding, setFolidng] = useState(false);

    const { data : user } = useQuery('USER', {});
    const { data: pItem, isSuccess} = useGetInoutInfo({sno:param.sno});
    const { data: itemInfo, refetch: itemRefetch,remove} = useGetItemByTno(result);
    const { data : ioRetStList} = useGetCodeList('io_ret_st');
    const { data : inoutHistList, isLoading: inoutHistLoading } = useGetInoutHistSel({sno:param.sno});
    const { mutate } = useSetInoutHist();

    const [normal] = useSound('/sound/normal.mp3');
    const [fix] = useSound('/sound/fix.mp3');
    const [nonValid] = useSound('/sound/countOver.mp3');

    // const [deviceId, setDeviceId] = useState(null);

    // usePrompt('aaaa',true);
    useEffect(() => {
        return history.listen(() => {
            if (history.action === "POP") {
                // 리스트 체크
                remove();
                navigate(history.location.pathname,{state:{sno:param.sno}})
            }
            
        });
    }, [history]);

    useEffect(()=>{
        if(result && result.tid){
            itemRefetch();
        }
    },[result])

    useEffect(()=>{
        if(itemInfo && itemInfo.length===0) {
            setMsg('등록되어있지 않은 자산입니다.');
            setFixMsg('');
            nonValid();
        }else if(itemInfo && itemInfo.length>0){
            if(itemInfo[0].status === ITEM_STATUS.NORMAL){
                
                if(itemInfo[0].s_use_cnt30 < 3){
                    let relCheck = false;
                    if(pItem[0].iot_tp === IOT_TP.SEARCH && (pItem[0].sub_tp === SUB_TP.TRAFFIC || pItem[0].sub_tp === SUB_TP.NUMBER)){
                        relCheck = (itemInfo[0].rid && itemInfo[0].rid > 0) ? true : false;
                    }else{
                        relCheck = true;
                    }
                    if(relCheck){
                        if((inoutHistList.findIndex((item)=>item.tid === itemInfo[0].tid)<0)&&itemInfo[0].is_ing !== 1){
                            if(sendList.findIndex((item)=>item.tid === itemInfo[0].tid)<0){
                                handleAddSendList();
                                setMsg('최근 30일 '+itemInfo[0].s_use_cnt30+'회 사용');
                                let fixMsgTemp = '고장횟수 : ('+itemInfo[0].cat_nm.substring(0,1)+')' + (itemInfo[0].b_cnt===null? 0:itemInfo[0].b_cnt);
                                fixMsgTemp += itemInfo[0].r_cid ? ' / ('+itemInfo[0].r_cat_nm.substring(0,1)+')' + (itemInfo[0].r_b_cnt===null?0:itemInfo[0].r_b_cnt):'';
                                setFixMsg(fixMsgTemp);
                                normal();
                            }else{
                                setMsg('이미 추가 되었습니다.');
                                setFixMsg('');
                                nonValid();
                            }
                        }else{
                            setMsg('이미 반출 되었습니다.');
                            setFixMsg('');
                            nonValid();
                        }
                    }else{
                        setMsg('연계자산이 설정되어있지 않습니다.');
                        setFixMsg('');
                        nonValid();
                    }
                }else{
                    setMsg('자산의 최근 30일 사용횟수를 초과하였습니다. ['+itemInfo[0].s_use_cnt30 +' 회]');
                    setFixMsg('');
                    nonValid();
                }
            }else{
                setMsg('자산의 상태를 확인해주세요(고장/파손등)');
                setFixMsg('');
                fix();
            }
        }
    },[itemInfo])

    // const handleDevices = useCallback(
    //     mediaDevices => {
    //         const frontCamera = mediaDevices.find(media => /front|user|selfie/i.test(media.label));
    //         if (frontCamera) {
    //             setDeviceId(frontCamera.deviceId);
    //         }
    //     }, [setDeviceId]
    // );

    // useEffect(()=>{
    //     navigator.mediaDevices.enumerateDevices().then(handleDevices);
    //   }, [handleDevices]);

    const handleScan = (sresult) => {
        // if (sresult && sresult.data) {
        //     if(sresult.data.indexOf('TAMS')>-1){
        //         const target = sresult.data.replace('TAMS','')
        //         target !== result.tid && setResult({tid:target});
        //         // setResult({tno:sresult.data});
        //     }else{
        //         setMsg('잘못된 QR CODE입니다.');
        //         setFixMsg('');
        //         nonValid();
        //     }

        // }

        //20251107
        if (sresult && sresult?.text) {
            if(sresult?.text.indexOf('TAMS')>-1){
                const target = sresult?.text.replace('TAMS','');
                target !== result?.tid && setResult({tid:target});
                // setResult({tno:sresult.data});
            }else{
                setMsg('잘못된 QR CODE입니다.');
                setFixMsg('');
                nonValid();
            }
        }
    };

    const handleError = (error) => {
        console.log(error);
    };

    const handleAddSendList = () => {
        queryClient.setQueryData('OPA',{status:true})
        const target = {
            ...itemInfo[0],
            id:sendList.length+1,
            sno: param.sno,
            ret_st: ITEM_STATUS.NORMAL,
            ret_st_nm: '일반',
            reg_id: user.uid,
            io_st: 'O',
            pri_check: false,
            rel_check: false
        }
        setSendList([...sendList,target])
        setMsg('');
    }

    const handleOutClick = useCallback((sendList) => {
        const sendTarget = {
            mode: 'POST_LIST',
            list: sendList
        }
        mutate(
            sendTarget,
            {
                onSuccess:()=>{
                    navigate(-1);
                    setMsgOpen(false);
                    setRetMsg('');
                    setListOpen(false);
                    setSendList([]);
                }
            }
            )
    });

    const handleConfirm = () => {
        setRetMsg('반출등록 완료 하시겠습니까?');
        setMsgOpen(true);
    }

    const handleClose = (type) => {
        setRetMsg('');
        setMsgOpen(false);
        // setListOpen(false);
        // setSendList([]);
        // if(type==='CLOSE'){
        //     navigate(-1);
        // }
    }

    const handleItemClick = () => {
        setSendList(sendList.filter((item)=> item.tid !== selectItem.tid))
    }

    const rowStatus = (param) => {
        return selectItem && param.row.tid === selectItem.tid && 'selected'
    }

    return (
        <React.Fragment>
            <div style={{padding: '0rem 1rem',display:'flex',alignItems:'center',justifyContent:'flex-start',gap:'8px'}}>
                <img src={`/images/ic_back_arrow.svg`} style={{width:'1.15rem'}} onClick={()=>navigate(-1)}/>
                <NaviText target={[{text:pItem ? pItem[0].iot_nm : ''},{text:'반출'}]} />
            </div>
            <MainWrap>
                <QRWrapper>
                    <img src={`/images/back_qr_radar.svg`} style={{ display: 'block', position: 'absolute', width: 'calc(100% - 8rem)',zIndex:1, opacity:'0.8'}} alt='' />
                    <QrReader
                        // delay={delay}
                        // // facingMode={'environment'}
                        // // deviceId={deviceId}
                        // constraints={{ facingMode: 'environment' }}
                        // onError={handleError}
                        // onScan={handleScan}
                        //20251107

                        scanDelay={delay}
                        onResult={(result, error) => {
                            if (result) handleScan(result);
                            if (error) handleError(error);
                        }}       

                        constraints={{ facingMode: 'environment', advanced: [{ zoom: 3.0 }]  }}
                        videoStyle={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        }}            
                    />
                </QRWrapper>
                {msg && <h3 style={{margin:0,marginTop:'4px', padding:0, color:theme.color.secondary.red}}>{msg}</h3>}
                {fixMsg && <h3 style={{margin:0,marginTop:'4px', padding:0, color:theme.color.secondary.red}}>{fixMsg}</h3>}
                {(itemInfo && itemInfo.length > 0) &&
                    <React.Fragment>
                        <Row style={{marginTop:'4px',width:'100%',padding:'1rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                            <TextField
                                id='tno' 
                                label='자산번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].tno}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='lot_no' 
                                label='표기번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].lot_no}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                label='구분'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].pcat_nm}
                            />
                            <TextField
                                label='분류'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].cat_nm}
                            />
                            <TextField 
                                    id='model_nm' 
                                    label='모델명' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].model_nm}
                                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                                />
                            <TextField
                                label='상태'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].status_nm}
                            />
                        </Row>
                        <Row style={{width:'100%',padding:'0rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                            {itemInfo[0].s_use_cnt30 > 2 ? <Button style={{background:theme.color.black[10],color:theme.color.black[40],margin:0,width:'100%'}} onClick={handleAddSendList}>수동담기</Button>:<div/>}
                            <Button style={{margin:0,width:'100%'}} onClick={()=>setListOpen(true)}>완료하기</Button>
                        </Row>
                        <FoldingBar onClick={setFolidng}/>
                        <Collapse in={folding}>
                            <Row style={{width:'100%',padding:'0.5rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                                <TextField 
                                    id='model_sub' 
                                    label='모델유형' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].model_sub}
                                />
                                <TextField 
                                    id='location' 
                                    label='위치' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].location}
                                />
                                <TextField 
                                    id='serial_no' 
                                    label='시리얼넘버' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].serial_no}
                                />
                                <TextField 
                                    id='maf_date'
                                    label='제조일자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && moment(itemInfo.maf_date).format('YYYY-MM-DD')}
                                />
                                <TextField 
                                    id='pur_date'
                                    label='구매일자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && moment(itemInfo.pur_date).format('YYYY-MM-DD')}
                                />
                                <TextField 
                                    id='pur_tpnm'
                                    label='구매구분' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].pur_tpnm}
                                />
                                <TextField 
                                    id='pur_price'
                                    label='구매가격' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].pur_price}
                                />
                                <TextField 
                                    id='uid1'
                                    label='책임자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].uid1_nm}
                                />
                                <TextField 
                                    id='ui2'
                                    label='부책임자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].uid2_nm}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem'}}>
                                <TextField 
                                    id='spec' 
                                    label='사양' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].spec}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem'}}>
                                <TextField 
                                    id='descr1' 
                                    label='비고1' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].descr1}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem 1rem 1rem'}}>
                                <TextField 
                                    id='descr2' 
                                    label='비고2' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].descr2}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem 1rem 1rem'}}>
                                <TextField 
                                    id='io_descr' 
                                    label='반출입 관리 메모' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].io_descr}
                                />
                            </Row>
                        </Collapse>
                    </React.Fragment>
                }
                {(sendList && sendList.length > 0) &&
                    <Fab onClick={()=>setListOpen(true)}>
                        <img src={'/images/ic_up_right_arrow.svg'} alt='' style={{width:'1rem'}} />
                        {sendList.length}
                    </Fab>
                }
            </MainWrap>
            <Drawer 
                open={listOpen}
                onClose={()=>setListOpen(false)}
                anchor={'right'}
            >
                <div style={{padding:'1rem', width:'85vw',maxHeight:'calc(100vh - 2rem)'}}>
                    <h3 style={{margin:0}}>반출 대상 목록</h3>
                    <DrawerInner>
                        <CommonDataGrid
                            // isLoading={itemLoading}
                            list={sendList}
                            columns={columns}
                            showCount={sendList.length}
                            getRowClassName={rowStatus}
                            autoHeight={true}
                            onRowClick={(e)=>{setSelectItem(e.row)}}
                            />
                    </DrawerInner>
                    <Row style={{marginTop:'8px',width:'100%', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <Button onClick={handleItemClick} style={{width:'100%',margin:0,marginTop:'1rem'}}>목록에서빼기</Button>
                        <Button onClick={handleConfirm} style={{width:'100%',margin:0,marginTop:'1rem'}}>반출완료</Button>
                    </Row>
                </div>
            </Drawer>
            <MobileMsgModal open={msgOpen}>
                <div>
                    <h3 style={{margin:0}}>{retMsg}</h3>
                    <Row style={{width:'100%',display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <Button onClick={handleClose}>취소</Button>
                        <Button onClick={()=>handleOutClick(sendList)}>확인</Button>
                        {/* <Button onClick={()=>handleClose('NEXT')}>계속</Button>
                        <Button onClick={()=>handleClose('CLOSE')}>완료</Button> */}
                    </Row>
                </div>
            </MobileMsgModal>
            
        </React.Fragment>
    )
}

export default OutControl;